module.exports = __webpack_public_path__ + "img/003.c2cac3b6.png";